module.exports = __webpack_public_path__ + "img/assigned.07d98221.svg";